module.exports = __webpack_public_path__ + "media/images/ads/bulk-selection-5e9d8f0b718016c9abf6543e4eac5afc.png";